
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30654',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30654",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55136",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8235",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11684",
  "I18n": "static-7.1651",
  "quartz": "static-1.7312",
  "quartz-config": "static-1.1090",
  "quartz-core": "static-1.6531",
  "react-dlb": "static-1.83",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.855",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55123",
  "feedback-utils": "static-1.55127",
  "forms-embed-utils-lib": "static-1.4676",
  "forms-utils-lib": "static-1.12955",
  "foundations-assets": "static-1.5085",
  "foundations-components": "static-1.8320",
  "foundations-theming": "static-1.4655",
  "hub-http": "static-1.6427",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11991",
  "icons": "static-2.668",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4063",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16913",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5487",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.491",
  "tinymce-plugins": "static-1.58030",
  "transmute": "static-2.85",
  "ui-images": "static-2.1215",
  "UIComponents": "static-3.8630",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3545",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3589",
  "quartz-webpack": "static-1.3536",
  "foundations-theming-specialty": "static-1.2371",
  "property-description-translator": "static-1.4049",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3346",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4533",
  "jasmine-runner": "static-1.6664",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.859",
  "hubspotter-http": "static-1.4797",
  "mobile-manifest-mixins": "static-1.556",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.987",
  "quartz-head": "static-1.977",
  "quartz-i18n": "static-1.987",
  "quartz-routing": "static-1.742",
  "quartz-test": "static-1.987",
  "quartz-tracking": "static-1.691",
  "trellis-components": "static-1.2380",
  "ui-fonts": "static-1.946",
  "usage-tracker-container": "static-1.7552",
  "usage-tracker-core": "static-1.7412",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7457",
  "reference-resolvers": "static-1.8388",
  "sanitize-text": "static-1.8357",
  "PatternValidationJS": "static-1.3107",
  "ReduxMessenger": "static-2.10575",
  "sanitize": "static-1.4687",
  "outpost": "static-1.4374",
  "rpc-client-utils": "static-1.4869",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4589",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9635",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.51",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2361",
  "bend-plugin-foundations-theming": "static-1.3138",
  "foundations-theming-base": "static-1.3640",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.227",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9478",
  "atom": "static-1.5286",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8072",
  "ContentUtils": "static-1.68961",
  "data-token-picker": "static-1.16762",
  "file-manager-components": "static-1.24242",
  "FileManagerCore": "static-1.39741",
  "FileManagerLib": "static-1.39882",
  "frontend-preferences-client": "static-1.8136",
  "hub-http-contrib": "static-1.3251",
  "interframe": "static-3.4965",
  "layout-dnd-components": "static-1.12833",
  "layout-dnd-utils": "static-1.11808",
  "property-translator": "static-1.5605",
  "react-codemirror": "static-1.10850",
  "react-colorpicker": "static-2.10419",
  "reference-resolvers-lite": "static-1.8305",
  "rich-text-lib": "static-1.20181",
  "tinymce-data": "static-1.41001",
  "tinymce-themes": "static-1.56886",
  "ui-addon-emoji-picker": "static-1.10095",
  "ui-addon-sales-email": "static-1.5422",
  "ui-brand-identity-lib": "static-1.16048",
  "bender-build-tools": "static-1.3323",
  "hub-http-shared-msw-handlers": "static-1.10458",
  "hubspotter-http-shared-msw-handlers": "static-1.10456",
  "usage-tracker-session-replay": "static-1.5248",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1164",
  "tanstack-virtual": "static-1.33",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.279",
  "chirp-fetch": "static-1.2097",
  "chatspot-core": "static-1.22377",
  "copilot-toolkit": "static-1.11664",
  "customer-data-objects-ui-components": "static-1.13240",
  "data-fetching-client": "static-1.9867",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4968",
  "ui-addon-video-player": "static-1.8916",
  "ui-coaching-tips": "static-1.29131",
  "usage-tracker": "static-1.7562",
  "cms-field-types": "static-1.5025",
  "content-icons-ui": "static-1.2291",
  "integrations-lib": "static-1.16803",
  "customer-data-objects": "static-1.7893",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1453",
  "apollo-link-hub-http": "static-2.4865",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.33",
  "immerable": "static-1.4358",
  "ui-addon-iframeable": "static-1.9283",
  "video-components-external": "static-1.11937",
  "video-data-lib": "static-1.35595",
  "audio-components": "static-1.6219",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29672",
  "FileManagerImages": "static-1.37393",
  "foundations-components-legacy": "static-1.1345",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.529",
  "ui-universal-auth": "static-1.9229",
  "urlinator": "static-1.4742",
  "video-components": "static-1.13939",
  "video-embed": "static-1.36429",
  "ts-schema": "static-1.4226",
  "ContentData": "static-1.69036",
  "layout-data-lib": "static-1.10133",
  "react-dnd-compat": "static-1.4824",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1754",
  "external-options-client-types": "static-1.4272",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7104",
  "hs-promise-utils": "static-1.5803",
  "inbound-db-properties-service-client": "static-1.3991",
  "NamespacedHubStyle": "static-2.9195",
  "growth-onboarding-confetti": "static-1.3270",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11357",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5699",
  "magpie-types": "static-1.5159",
  "simple-logging-lib": "static-1.3259",
  "avatar-components": "static-1.2707",
  "customer-data-ui-utilities": "static-1.10034",
  "growth-onboarding-feedback-components": "static-1.6791",
  "flux-actions": "static-1.355",
  "hubspot-apollo-client": "static-1.5087",
  "integrations-error-boundary-lib": "static-1.14218",
  "integrations-tracking-lib": "static-1.5817",
  "laboratory-lib": "static-3.7361",
  "native-integrations-shared-strings": "static-1.7986",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10471",
  "unified-auth": "static-1.743",
  "breeze-engine-chat-components": "static-1.431",
  "breeze-engine-core": "static-1.731",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.7950",
  "content-media-composition-data-lib": "static-1.12983",
  "content-media-compositions": "static-2.16990",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19279",
  "unified-auth-core-lib": "static-1.1025",
  "social-insights-client-types": "static-1.22606",
  "advanced-menus-core": "static-1.15457",
  "advanced-menus-lib": "static-1.12349",
  "ExportDialog": "static-6.10587",
  "ui-memberships-settings-lib": "static-1.34625",
  "conditional-properties-service-client": "static-1.3943",
  "crm-pipelines-api-client-types": "static-1.4282",
  "fdsr-migration-layer": "static-1.223",
  "framework-builder-read-service-client": "static-1.4152",
  "framework-data-schema-quick-fetch": "static-1.7009",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3837",
  "persist-promise": "static-1.3911",
  "foundations-components-test-utils": "static-1.5803",
  "reactive-lib": "static-1.932",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.546",
  "universal-page-editor-lib": "static-1.3221",
  "adobe-sign-auth-lib": "static-1.264",
  "ads-unified-auth-lib": "static-1.796",
  "google-sheets-integration-lib": "static-1.841",
  "microsoft-drive-integration-lib": "static-1.962",
  "surveymonkey-integration-lib": "static-1.285",
  "slack-ui-library": "static-1.10609",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3942",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15456",
  "simple-menus-lib": "static-1.16973",
  "crm-record-cards-service-types": "static-1.3730",
  "location-customization-utils-lib": "static-1.9889",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30654",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55136",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8235",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11684",
  "I18n": "/I18n/static-7.1651",
  "quartz": "/quartz/static-1.7312",
  "quartz-config": "/quartz-config/static-1.1090",
  "quartz-core": "/quartz-core/static-1.6531",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.855",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55123",
  "feedback-utils": "/feedback-utils/static-1.55127",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4676",
  "forms-utils-lib": "/forms-utils-lib/static-1.12955",
  "foundations-assets": "/foundations-assets/static-1.5085",
  "foundations-components": "/foundations-components/static-1.8320",
  "foundations-theming": "/foundations-theming/static-1.4655",
  "hub-http": "/hub-http/static-1.6427",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11991",
  "icons": "/icons/static-2.668",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4063",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16913",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5487",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tinymce-plugins": "/tinymce-plugins/static-1.58030",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1215",
  "UIComponents": "/UIComponents/static-3.8630",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3545",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3589",
  "quartz-webpack": "/quartz-webpack/static-1.3536",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2371",
  "property-description-translator": "/property-description-translator/static-1.4049",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3346",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4533",
  "jasmine-runner": "/jasmine-runner/static-1.6664",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.859",
  "hubspotter-http": "/hubspotter-http/static-1.4797",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.987",
  "quartz-head": "/quartz-head/static-1.977",
  "quartz-i18n": "/quartz-i18n/static-1.987",
  "quartz-routing": "/quartz-routing/static-1.742",
  "quartz-test": "/quartz-test/static-1.987",
  "quartz-tracking": "/quartz-tracking/static-1.691",
  "trellis-components": "/trellis-components/static-1.2380",
  "ui-fonts": "/ui-fonts/static-1.946",
  "usage-tracker-container": "/usage-tracker-container/static-1.7552",
  "usage-tracker-core": "/usage-tracker-core/static-1.7412",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7457",
  "reference-resolvers": "/reference-resolvers/static-1.8388",
  "sanitize-text": "/sanitize-text/static-1.8357",
  "PatternValidationJS": "/PatternValidationJS/static-1.3107",
  "ReduxMessenger": "/ReduxMessenger/static-2.10575",
  "sanitize": "/sanitize/static-1.4687",
  "outpost": "/outpost/static-1.4374",
  "rpc-client-utils": "/rpc-client-utils/static-1.4869",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4589",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9635",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.51",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2361",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3138",
  "foundations-theming-base": "/foundations-theming-base/static-1.3640",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.227",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9478",
  "atom": "/atom/static-1.5286",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8072",
  "ContentUtils": "/ContentUtils/static-1.68961",
  "data-token-picker": "/data-token-picker/static-1.16762",
  "file-manager-components": "/file-manager-components/static-1.24242",
  "FileManagerCore": "/FileManagerCore/static-1.39741",
  "FileManagerLib": "/FileManagerLib/static-1.39882",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8136",
  "hub-http-contrib": "/hub-http-contrib/static-1.3251",
  "interframe": "/interframe/static-3.4965",
  "layout-dnd-components": "/layout-dnd-components/static-1.12833",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11808",
  "property-translator": "/property-translator/static-1.5605",
  "react-codemirror": "/react-codemirror/static-1.10850",
  "react-colorpicker": "/react-colorpicker/static-2.10419",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8305",
  "rich-text-lib": "/rich-text-lib/static-1.20181",
  "tinymce-data": "/tinymce-data/static-1.41001",
  "tinymce-themes": "/tinymce-themes/static-1.56886",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10095",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5422",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16048",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10458",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10456",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5248",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1164",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.279",
  "chirp-fetch": "/chirp-fetch/static-1.2097",
  "chatspot-core": "/chatspot-core/static-1.22377",
  "copilot-toolkit": "/copilot-toolkit/static-1.11664",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13240",
  "data-fetching-client": "/data-fetching-client/static-1.9867",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4968",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8916",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29131",
  "usage-tracker": "/usage-tracker/static-1.7562",
  "cms-field-types": "/cms-field-types/static-1.5025",
  "content-icons-ui": "/content-icons-ui/static-1.2291",
  "integrations-lib": "/integrations-lib/static-1.16803",
  "customer-data-objects": "/customer-data-objects/static-1.7893",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1453",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4865",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4358",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9283",
  "video-components-external": "/video-components-external/static-1.11937",
  "video-data-lib": "/video-data-lib/static-1.35595",
  "audio-components": "/audio-components/static-1.6219",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29672",
  "FileManagerImages": "/FileManagerImages/static-1.37393",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1345",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.529",
  "ui-universal-auth": "/ui-universal-auth/static-1.9229",
  "urlinator": "/urlinator/static-1.4742",
  "video-components": "/video-components/static-1.13939",
  "video-embed": "/video-embed/static-1.36429",
  "ts-schema": "/ts-schema/static-1.4226",
  "ContentData": "/ContentData/static-1.69036",
  "layout-data-lib": "/layout-data-lib/static-1.10133",
  "react-dnd-compat": "/react-dnd-compat/static-1.4824",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1754",
  "external-options-client-types": "/external-options-client-types/static-1.4272",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7104",
  "hs-promise-utils": "/hs-promise-utils/static-1.5803",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3991",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9195",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3270",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11357",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5699",
  "magpie-types": "/magpie-types/static-1.5159",
  "simple-logging-lib": "/simple-logging-lib/static-1.3259",
  "avatar-components": "/avatar-components/static-1.2707",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10034",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6791",
  "flux-actions": "/flux-actions/static-1.355",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5087",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14218",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5817",
  "laboratory-lib": "/laboratory-lib/static-3.7361",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7986",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10471",
  "unified-auth": "/unified-auth/static-1.743",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.431",
  "breeze-engine-core": "/breeze-engine-core/static-1.731",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.7950",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12983",
  "content-media-compositions": "/content-media-compositions/static-2.16990",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19279",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1025",
  "social-insights-client-types": "/social-insights-client-types/static-1.22606",
  "advanced-menus-core": "/advanced-menus-core/static-1.15457",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12349",
  "ExportDialog": "/ExportDialog/static-6.10587",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34625",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3943",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4282",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.223",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4152",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7009",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3837",
  "persist-promise": "/persist-promise/static-1.3911",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5803",
  "reactive-lib": "/reactive-lib/static-1.932",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.546",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3221",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.264",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.796",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.841",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.962",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.285",
  "slack-ui-library": "/slack-ui-library/static-1.10609",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3942",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15456",
  "simple-menus-lib": "/simple-menus-lib/static-1.16973",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3730",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9889",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
